import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/OIP-3819782714-removebg-preview.png'; // Tell webpack this JS file uses this image

const Navbar: React.FC = () => {
  return (
    <nav style={{
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'Outfit',
      alignItems: 'center',
      padding: '.5rem',
      flexWrap: 'wrap'
    }}>
      <div style={{ display: 'flex', marginBottom: '0.25rem',flexDirection: 'column' }}>
        <Link to="/" style={{ textDecoration: 'none', color: '#000', display: 'flex', flexDirection: 'row' }}>
        <img src={logo} alt="Logo" width="130em" height="80em"/> <h2>ISSBY</h2>
</Link>
      </div>
      <div style={{
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '600px'
      }}>
        {/*
        <Link to="/" style={{ textDecoration: 'none', color: '#000' }}>Homepage</Link>
        <Link to="/user" style={{ textDecoration: 'none', color: '#000' }}>Create an Account</Link>
        <Link to="/product_db" style={{ textDecoration: 'none', color: '#000' }}>Matching Tool</Link>
*/}
      </div>
    </nav>
  );
};

export default Navbar;
